export const isRunningOnPlaywright = localStorage.getItem('isPlaywright') === 'true'
export const isRunningReleaseTest = localStorage.getItem('isReleaseTest') === 'true'
export const isAutomatedBrowser = isRunningOnPlaywright || isRunningReleaseTest
